/**
 * 系统管理模块接口
*/
import axios from '../request';
// import { Base } from '../index';

export default {
  // 获取全部城市信息
  getAllCityInfo: () =>
    axios.post('/engineering/city/cities'),
  // 导出授权
  GETEXPORTTOKENDATA: (params) =>
    axios.post('/usercore/sysUser/getAuthCode', params),
  // 上传文件接口
  uploadFileRequest: (params) =>
    axios.post('/file/file/upload', params),
  //获取公司名称
  getCompanyLists: (params) =>
    axios.post('/engineering/company/findAll', params),
  // 获取文件二进制流
  requestFileBlob: (params) => {
    return axios({
      method: 'post',
      url: `/file/file/down?authcode=${params}`,
      responseType: 'blob',
    })
  },
  // 预览文件 
  requestPervewFile: (params) =>
    axios.get('/file/file/preview', {params}),
  //修改密码
  updatePasswordInfo: params =>
    axios.post('/usercore/sysUser/updatePass', params),  
  // 获取验证码
  getCodeImage: () =>
    axios.get('/usercore/code/captchaImage'),

    /**
   * 登录接口 
  */
  // 登录
  userLogin: params => 
    axios.post(`/usercore/login`, params),
  // 退出登录
  logingOut: params =>
    axios.post('/usercore/login/logout', params),

  /**
   * 用户管理接口 
  */

  // 添加用户信息
  createUserInfo: params => 
    axios.post('/usercore/sysUser/addUser', params),
  // 删除用户信息
  deleteUserInfo: params => 
    axios.post(`/usercore/sysUser/delete`, params),
  // 修改用户信息
  updateUserInfo: params => 
    axios.post(`/usercore/sysUser/addUser`, params),
  // 查询用户信息
  searchUserInfo: params => {
    return axios({
      url: '/usercore/sysUser/findList',
      method: 'post',
      data: {
        username: params.username,
        telphone: params.telphone
      },
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      }
    })
  },
  // 获取用户详情信息
  getUserInfo: params =>
    axios.post(`/usercore/sysUser/queryVersion/${params}`),
  // 修改用户角色权限
  updateUserRole: params => 
    axios.post('/usercore/sysUser/updateUserRole', params),
  // 根据用户获取其部门信息
  getUserDepartmentInfo: params =>
    axios.post('/usercore/sysDepart/userDepartList', params),
  // 为用户配置部门信息
  configUserDepartment: params =>
    axios.post('/usercore/sysUser/updateDepartForUser', params),
  // 获取当前用户当前菜单下的按钮权限信息
  getUserMenuButtonInfo: params =>
    axios.post('/usercore/sysMenus/menuEnableButtons', params),
  /**
   * 角色管理接口 
  */

  // 增加角色信息
  createRoleInfo: params => 
    axios.post(`/usercore/sysRoles/addRole`, params),
  // 修改角色信息
  updateRoleInfo: params => 
    axios.post(`/usercore/sysRoles/addRole`, params),
  // 删除角色信息
  deleteRoleInfo: params => 
    axios.post(`/usercore/sysRoles/delete`, params),
  // 查询角色信息
  searchRoleInfo: params => {
    return axios({
      url: '/usercore/sysRoles/findList',
      method: 'post',
      data: {
        roleName: params.roleName
      },
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      }
    })
  },
  // 角色菜单权限信息
  configRoleInfo: params =>
    axios.post(`/usercore/sysMenus/findTreeList`, params),
  // 获取全部角色信息
  getAllRolesInfo: params =>
    axios.post('/usercore/sysRoles/findAll', params),
  // 根据角色查询所有权限
  getRoleInfoMenus: params => 
    axios.post(`/usercore/sysMenus/allRoleMenu`, params),
  // 配置角色菜单权限
  configRoleMenusInfo: params => 
    axios.post('/usercore/sysRoles/updateMenuForRole', params),
  // 获取角色下配置的url信息
  getUserConfigUrlInfo: params => {
    return axios({
      url: '/usercore/sysUrl/roleUrlList',
      method: 'post',
      data: params,
      headers: {
        pageNum: 1,
        pageSize: 10000
      }
    })
  },

  /**
   * 菜单管理接口 
  */

  // 添加路由菜单信息
  createRouterMenusInfo: params => 
    axios.post(`/usercore/sysMenus/addMenu`, params),
  // 删除路由菜单信息
  deleteRouterMenusInfo: params => 
    axios.post(`/usercore/sysMenus/delete`, params),
  // 修改路由菜单信息
  updateRouterMenusInfo: params => 
    axios.post(`/usercore/sysMenus/addMenu`, params),
  // 查询路由菜单信息
  searchRouterMenusInfo: params => 
    axios.post(`/usercore/sysMenus/findTreeList`, params),
  // 为菜单配置按钮信息
  menusConfigButton: params =>
    axios.post('/usercore/sysMenus/addMenuButton', params),
  // 根据菜单获取该菜单下配置的按钮信息
  getMenusButtonInfo: params => {
    return axios({
      method: 'post',
      url: '/usercore/sysButton/menuButtonList',
      headers: {
        pageNum: 1,
        pageSize: 100000
      },
      data: params
    })
  },
  // 根据菜单获取该菜单下配置的url信息
  getMenusUrlInfo: params => {
    return axios({
      url: '/usercore/sysUrl/menuUrlList',
      method: 'post',
      headers: {
        pageNum: 1,
        pageSize: 10000
      },
      data: params
    })
  },
  // 为菜单配置url信息
  menusConfigUrlInfo: params =>
    axios.post('/usercore/sysMenus/addMenuUrls', params),
  /* 
  * 部门模块接口
  */

  // 查询部门信息
  searchDepartmentInfo: params =>
    axios.post('/usercore/sysDepart/findAll', params),
  // 添加部门信息
  insertDepartmentInfo: params =>
    axios.post('/usercore/sysDepart/addDepart', params),
  // 修改部门信息
  updateDepartmentInfo: params =>
    axios.post('/usercore/sysDepart/addDepart', params),
  // 删除部门信息
  deleteDepartmentInfo: params =>
    axios.post('/usercore/sysDepart/delete', params),
  
  /**
   * 按钮管理模块接口
  */
 // 查询按钮配置列表信息
  searchButtonConfigInfo: params => {
    return axios({
      url: '/usercore/sysButton/findList',
      method: 'post',
      data: {
        params: params.buttonName
      },
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      }
    })
  },
  // 添加按钮信息
  insertButtonInfo: params =>
    axios.post('/usercore/sysButton/addButton', params),
  // 修改按钮信息
  updateButtonInfo: params =>
    axios.post('/usercore/sysButton/addButton', params),
  // 删除按钮信息
  deleteButtonInfo: params =>
    axios.post('/usercore/sysButton/delete', params),
  // 获取按钮类型信息
  getButtonType: () =>
    axios.post('/usercore/sysButton/buttonTypes'),
  // 获取全部按钮信息
  getAllButtonInfo:params => {
    return axios({
      url: '/usercore/sysButton/roleButtonList',
      method: 'post',
      headers: {
        pageNum: 1,
        pageSize: 10000
      },
      data: params
    })
  },

  /**
   * 日志管理模块
  */
  
  // 查询日志信息
  searchLogInfo: params => {
    return axios({
      url: '/usercore/sysLogs/findList',
      method: 'post',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      }
    })
  },

  /**
   * Url管理模块
  */

  // 查询url列表信息
  searchUrlInfoList: params => {
    return axios({
      url: '/usercore/sysUrl/findList',
      method: 'post',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      }
    })
  },
  // 添加url信息
  insertUrlInfo: params =>
    axios.post('/usercore/sysUrl/addUrl', params),
  // 修改url信息
  updateUrlInfo: params => 
    axios.post('/usercore/sysUrl/addUrl', params),
  // 删除url信息
  deleteUrlInfo: params =>
    axios.post('/usercore/sysUrl/delete', params),

  /**
   * PDA菜单管理
  */

  // 查询PDA菜单信息
  searchPDAMenuList: (params) =>
    axios({
      method: 'post',
      url: '/usercore/pdaMenu/findList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: {
        menuName: params.menuName
      }
    }),
  // 新增 修改 PDA菜单信息
  insertPDAMenuInfo: (params) =>
    axios.post('/usercore/pdaMenu/addPdaMenu', params),
  // 删除PDA 菜单信息
  deletePDAMenuInfo: (params) =>
    axios.post('/usercore/pdaMenu/delete', params),
  // 根据角色获取菜单信息
  getUserPDAMenuInfo: (params) =>
    axios({
      method: 'post',
      url: '/usercore/pdaMenu/selectList',
      headers: {
        pageNum: 1,
        pageSize: 100000
      },
      data: {
        roleId: params.roleId
      }
    }),
  // 为角色配置PDA菜单
  userConfigMenuInfo: (params) =>
    axios.post('/usercore/pdaMenu/addPdaRole', params),
  

  /**
   * 微信小程序菜单管理
  */
  searchWechatMenuList: (params) =>
    axios({
      method: 'post',
      url: '/usercore/mpMenu/findList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: {
        menuName: params.menuName
      }
    }),
  // 新增 修改微信小程序菜单信息
  insertWechatMenuInfo: (params) =>
    axios.post('/usercore/mpMenu/addMpMenu', params),
  // 删除微信小程序菜单信息
  deleteWechatMenuInfo: (params) =>
    axios.post('/usercore/mpMenu/delete', params),
  // 根据角色以及角色信息获取微信小程序菜单信息
  getUserWechatMneuList: (params) =>
    axios({
      method: 'post',
      url: '/usercore/mpMenu/selectList',
      headers: {
        pageNum: 1,
        pageSize: 100000
      },
      data: {
        roleId: params.roleId,
        menuType: params.menuType,
        menuName: params.menuName
      }
    }),
  // 为角色配置微信小程序菜单
  userConfigWechatMenu: (params) =>
    axios.post('/usercore/mpMenu/addMpMenuRole', params),
  // 获取标签下拉框
  getWechatTagData: () =>
    axios.post('/usercore/mpMenu/tagList'),

  // 登录大屏
  mainLogin: (params) =>
    axios.post('/usercore/thingJsLogin/login', params),
  // 登陆大屏后获取跳转地址
  getMainUsertargetUrl: (params) =>
    axios.post('/usercore/thingJsLogin/thingJsCompany', params),
}